import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
interface Props {
  extraText?: string;
  price: number;
  unitOfMeasure?: string;
}
const Pricing = ({
  extraText,
  price,
  unitOfMeasure
}: Props) => {
  return <div className="quicklinks-banner__price-block" data-sentry-component="Pricing" data-sentry-source-file="index.tsx">
      <span className="price">
        {extraText && <span className="from">{extraText}</span>}
        {formatAsCurrency.formatIfUndefined(price)}
        {unitOfMeasure && <span className="each">{`/${unitOfMeasure}`}</span>}
      </span>
    </div>;
};
export default Pricing;